var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _g3, _path0, _g4, _path1, _path10, _g5, _path11, _path12, _path13, _g6, _path14, _path15, _path16, _path17, _path18, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPikkoWelcomeHome2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 419,
    viewBox: "0 0 393 419",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter0_f_0_1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.5,
    cy: 209.266,
    rx: 138,
    ry: 102.5,
    fill: "url(#paint0_linear_0_1)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.713 196.072L186.359 196.055C166.581 195.923 151.199 190.152 140.634 178.872C124.095 161.224 125.587 136.702 125.657 135.669L125.852 132.822L128.738 132.621C128.738 132.621 129.549 132.56 130.979 132.56C140.723 132.56 189.325 135.467 189.695 192.744L189.713 196.072Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.341 171.923L193.056 169.63C179.578 156.111 173.031 141.7 173.596 126.796C174.478 103.46 192.466 87.6643 193.236 87.0104L195.341 85.1846L197.455 87.0104C198.225 87.6643 216.213 103.46 217.095 126.796C217.659 141.7 211.113 156.111 197.635 169.63L195.341 171.923Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M203.178 196.072L203.204 192.811C203.567 136.68 251.196 133.831 260.736 133.831C262.146 133.831 262.941 133.891 262.941 133.891L265.761 134.089L265.96 136.878C266.029 137.891 267.491 161.913 251.283 179.216C240.939 190.271 225.855 195.927 206.464 196.055L203.178 196.072Z",
    fill: "url(#paint3_linear_0_1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.674 328.421V172.047C220.209 172.016 219.753 172.016 219.288 172.016H172.938V328.421H220.674ZM161.059 328.421H172.938V172.047H172.678C153.471 172.047 136.609 187.6 135.223 206.59L128.729 293.917C127.304 312.868 141.86 328.421 161.059 328.421ZM230.899 328.421C250.107 328.421 264.654 312.868 263.238 293.878L256.735 206.559C255.35 188.03 239.252 172.773 220.642 172.047V328.421H230.899Z",
    fill: "#FFDE59"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 205,
    y: 166,
    width: 62,
    height: 62
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M205.111 166.896H266.465V227.78H205.111V166.896Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 205,
    y: 166,
    width: 62,
    height: 62
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.794 166.908C218.846 166.908 205.117 180.532 205.117 197.35C205.117 214.161 218.846 227.793 235.794 227.793C252.735 227.793 266.471 214.161 266.471 197.35C266.471 180.532 252.735 166.908 235.794 166.908Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.117 166.908H266.471V227.793H205.117V166.908Z",
    fill: "white"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M257.733 218.347C240.53 229.117 215.42 220.418 210.564 214.896C216.807 223.87 219.235 224.215 227.559 227.322C236.23 230.083 240.678 233.88 243.86 233.88C247.675 233.88 245.271 227.845 246.981 227.322C251.49 225.941 252.53 233.88 257.733 233.88C263.282 233.88 259.814 221.454 259.12 219.728C258.565 218.347 258.08 218.002 257.733 218.347Z",
    fill: "#ECECFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M231.832 172.35C221.26 172.35 212.695 180.849 212.695 191.34C212.695 201.823 221.26 210.322 231.832 210.322C242.396 210.322 250.961 201.823 250.961 191.34C250.961 180.849 242.396 172.35 231.832 172.35Z",
    fill: "#3D1F1E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 232,
    width: 57,
    height: 64
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.834 232.775H224.544V295.66H168.834V232.775Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.684 312.13C194.855 312.13 193.047 311.879 191.259 311.366C189.46 310.864 187.722 310.11 186.035 309.115C184.348 308.11 182.741 306.894 181.226 305.447C179.7 304 178.296 302.352 177.003 300.514C175.709 298.665 174.558 296.665 173.547 294.494C172.527 292.334 171.668 290.043 170.971 287.631C170.274 285.23 169.748 282.747 169.385 280.195C169.031 277.633 168.859 275.06 168.859 272.448C168.859 269.845 169.031 267.262 169.385 264.71C169.748 262.158 170.274 259.676 170.971 257.264C171.668 254.862 172.527 252.571 173.547 250.411C174.558 248.24 175.709 246.241 177.003 244.392C178.296 242.553 179.7 240.905 181.226 239.458C182.741 238.011 184.348 236.795 186.035 235.79C187.722 234.795 189.46 234.042 191.259 233.539C193.047 233.027 194.855 232.775 196.684 232.775C198.513 232.775 200.321 233.027 202.11 233.539C203.908 234.042 205.646 234.795 207.333 235.79C209.02 236.795 210.627 238.011 212.142 239.458C213.668 240.905 215.072 242.553 216.366 244.392C217.659 246.241 218.811 248.24 219.821 250.411C220.841 252.571 221.7 254.862 222.397 257.264C223.094 259.676 223.62 262.158 223.983 264.71C224.337 267.262 224.509 269.845 224.509 272.448C224.509 275.06 224.337 277.633 223.983 280.195C223.62 282.747 223.094 285.23 222.397 287.631C221.7 290.043 220.841 292.334 219.821 294.494C218.811 296.665 217.659 298.665 216.366 300.514C215.072 302.352 213.668 304 212.142 305.447C210.627 306.894 209.02 308.11 207.333 309.115C205.646 310.11 203.908 310.864 202.11 311.366C200.321 311.879 198.513 312.13 196.684 312.13Z",
    fill: "#3D1F1E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 272,
    width: 49,
    height: 35
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M173.125 272.539H221.298V306.976H173.125V272.539Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.298 289.752C221.298 290.878 221.136 291.993 220.833 293.109C220.52 294.214 220.065 295.289 219.459 296.334C218.853 297.379 218.115 298.364 217.236 299.309C216.357 300.243 215.357 301.118 214.236 301.911C213.124 302.715 211.902 303.429 210.588 304.052C209.275 304.685 207.891 305.207 206.426 305.639C204.961 306.072 203.455 306.403 201.91 306.624C200.354 306.845 198.788 306.956 197.211 306.956C195.625 306.956 194.059 306.845 192.513 306.624C190.957 306.403 189.452 306.072 187.987 305.639C186.532 305.207 185.138 304.685 183.824 304.052C182.511 303.429 181.289 302.715 180.177 301.911C179.056 301.118 178.055 300.243 177.176 299.309C176.297 298.364 175.56 297.379 174.954 296.334C174.348 295.289 173.893 294.214 173.58 293.109C173.277 291.993 173.125 290.878 173.125 289.752C173.125 288.617 173.277 287.502 173.58 286.386C173.893 285.281 174.348 284.206 174.954 283.161C175.56 282.115 176.297 281.131 177.176 280.186C178.055 279.252 179.056 278.377 180.177 277.584C181.289 276.78 182.511 276.066 183.824 275.443C185.138 274.81 186.532 274.288 187.987 273.855C189.452 273.423 190.957 273.092 192.513 272.871C194.059 272.65 195.625 272.539 197.211 272.539C198.788 272.539 200.354 272.65 201.91 272.871C203.455 273.092 204.961 273.423 206.426 273.855C207.891 274.288 209.275 274.81 210.588 275.443C211.902 276.066 213.124 276.78 214.236 277.584C215.357 278.377 216.357 279.252 217.236 280.186C218.115 281.131 218.853 282.115 219.459 283.161C220.065 284.206 220.52 285.281 220.833 286.386C221.136 287.502 221.298 288.617 221.298 289.752Z",
    fill: "#FA5B5B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 167,
    width: 62,
    height: 62
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M125.594 167.313H186.948V228.198H125.594V167.313Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 167,
    width: 62,
    height: 62
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M156.271 167.327C139.33 167.327 125.594 180.951 125.594 197.769C125.594 214.58 139.33 228.212 156.271 228.212C173.211 228.212 186.948 214.58 186.948 197.769C186.948 180.951 173.211 167.327 156.271 167.327Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.594 167.327H186.948V228.212H125.594V167.327Z",
    fill: "white"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M133.224 218.002C150.427 228.771 168.947 223.869 181.85 215.24C176.23 222.144 171.999 225.25 162.704 228.702C153.964 231.463 153.4 232.844 150.219 232.844C146.403 232.844 147.143 228.19 145.433 227.666C140.924 226.286 139.884 232.499 134.681 232.499C128.4 232.499 130.103 222.144 130.796 220.418C131.351 219.037 132.877 217.656 133.224 218.002Z",
    fill: "#ECECFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 172,
    width: 40,
    height: 39
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M141.756 172.663H180.014V210.636H141.756V172.663Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 172,
    width: 40,
    height: 39
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M160.891 172.663C150.326 172.663 141.762 181.162 141.762 191.653C141.762 202.137 150.326 210.636 160.891 210.636C171.455 210.636 180.019 202.137 180.019 191.653C180.019 181.162 171.455 172.663 160.891 172.663Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.762 172.663H180.019V210.636H141.762V172.663Z",
    fill: "#3D1F1E"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M165.132 191.768C165.132 186.957 168.732 183.488 173.456 183.488C168.952 183.488 165.136 179.793 165.136 175.204C165.136 179.75 161.575 183.488 156.809 183.488C161.575 183.488 165.132 187.131 165.132 191.768Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M165.132 175.2L165.136 175.204M165.136 175.204C165.136 179.793 168.952 183.488 173.456 183.488C168.732 183.488 165.132 186.957 165.132 191.768C165.132 187.131 161.575 183.488 156.809 183.488C161.575 183.488 165.136 179.75 165.136 175.204Z",
    stroke: "white",
    strokeWidth: 0.804636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M226.173 191.768C226.173 186.957 229.773 183.488 234.497 183.488C229.993 183.488 226.177 179.793 226.177 175.204C226.177 179.75 222.616 183.488 217.85 183.488C222.616 183.488 226.173 187.131 226.173 191.768Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M226.173 175.2L226.177 175.204M226.177 175.204C226.177 179.793 229.993 183.488 234.497 183.488C229.773 183.488 226.173 186.957 226.173 191.768C226.173 187.131 222.616 183.488 217.85 183.488C222.616 183.488 226.177 179.75 226.177 175.204Z",
    stroke: "white",
    strokeWidth: 0.804636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 195,
    y: 281,
    width: 5,
    height: 1
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M195.43 281.008H199.086V281.467H195.43V281.008Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.086 281.237C199.086 281.252 199.074 281.267 199.051 281.282C199.027 281.297 198.992 281.311 198.946 281.325C198.9 281.339 198.844 281.352 198.778 281.365C198.711 281.377 198.635 281.389 198.55 281.399C198.466 281.41 198.373 281.42 198.273 281.428C198.173 281.436 198.068 281.443 197.957 281.449C197.846 281.455 197.732 281.459 197.614 281.462C197.496 281.465 197.377 281.467 197.258 281.467C197.137 281.467 197.019 281.465 196.901 281.462C196.783 281.459 196.669 281.455 196.558 281.449C196.447 281.443 196.341 281.436 196.242 281.428C196.142 281.42 196.049 281.41 195.965 281.399C195.88 281.389 195.804 281.377 195.737 281.365C195.67 281.352 195.614 281.339 195.568 281.325C195.522 281.311 195.488 281.297 195.464 281.282C195.441 281.267 195.43 281.252 195.43 281.237C195.43 281.222 195.441 281.207 195.464 281.192C195.488 281.178 195.522 281.163 195.568 281.149C195.614 281.135 195.67 281.122 195.737 281.11C195.804 281.097 195.88 281.086 195.965 281.075C196.049 281.064 196.142 281.055 196.242 281.047C196.341 281.038 196.447 281.031 196.558 281.025C196.669 281.02 196.783 281.015 196.901 281.012C197.019 281.009 197.137 281.008 197.258 281.008C197.377 281.008 197.496 281.009 197.614 281.012C197.732 281.015 197.846 281.02 197.957 281.025C198.068 281.031 198.173 281.038 198.273 281.047C198.373 281.055 198.466 281.064 198.55 281.075C198.635 281.086 198.711 281.097 198.778 281.11C198.844 281.122 198.9 281.135 198.946 281.149C198.992 281.163 199.027 281.178 199.051 281.192C199.074 281.207 199.086 281.222 199.086 281.237Z",
    fill: "#FA5B5B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_1",
    x: -48.2654,
    y: 0.000190735,
    width: 489.531,
    height: 418.531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 53.3827,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 58.5,
    y1: 209.266,
    x2: 334.5,
    y2: 209.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF276F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 157.653,
    y1: 132.56,
    x2: 157.653,
    y2: 196.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 195.345,
    y1: 85.1846,
    x2: 195.345,
    y2: 171.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 234.6,
    y1: 133.831,
    x2: 234.6,
    y2: 196.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPikkoWelcomeHome2);
export default __webpack_public_path__ + "static/media/pikkoWelcomeHome2.f748c368c14b024d0f09a0fed069be1a.svg";
export { ForwardRef as ReactComponent };